import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { currentBudgetSelector } from "../currentBudgetSelector";

export const currentBudgetPlannedAmountsSelector = createDraftSafeSelector(
  [currentBudgetSelector],
  (budget) => {
    return budget?.body?.planned_amounts ?? null;
  },
);
